import BiDashboard from "./bi-dashboard/reducer";
import BookingData from "./booking-data/reducer";
import Confirm from "./confirm/reducer"
import DailyDashboard from "./daily-dashboard/reducer";
import FlowSelection from "./flow-selection/reducer"
import Layout from "./layout/reducer";
import Loading from "./loading/reducer";
import Login from "./auth/login/reducer";
import Message from "./message/reducer"
import Profile from "./auth/profile/reducer";
import SummaryReport from "./summary-report/reducer";
import TPADailyReport from "./tpadaily-report/reducer";
import TPADailyReportList from './report-tpa-daily-report/reducer';
import GasCompositionReportList from './report-gas-composition-daily/reducer';
import ShiftReportList from './report-shift/reducer';
import DeliveryGasFuelGasReportList from './report-delivery-gas-fuel-gas/reducer';
import AverageGasReportList from './report-average-gas/reducer';
import GasDeliveryPerformanceReportList from './report-gas-delivery-performance/reducer';
import ActualSupplyDemandReportList from './report-actual-supply-demand/reducer';

import InputManageBooking from './input-management-booking/reducer';
import InputManageNomWeek from './input-management-nomweek/reducer';
import InputManageNomDay from './input-management-nomday/reducer';
import InputManageMeterDay from './input-management-meterday/reducer';
import InputManageMeterMonth from './input-management-metermonth/reducer';
import InputManageAllocation from './input-management-allocation/reducer';
import ViewerReportBooking from './viewer-report-booking/reducer';
import ViewerReportNomDay from './viewer-report-nomday/reducer';
import ViewerReportAllocation from './viewer-report-allocation/reducer';
import ViewerReportMeterMonth from './viewer-report-meteringmonth/reducer';


import { combineReducers } from "redux";

// Front

// Authentication




const rootReducer = combineReducers({
    // public
    Layout,
    Login,
    Profile,
    DailyDashboard,
    BiDashboard,
    BookingData,
    FlowSelection,
    Message,
    Loading,
    Confirm,
    SummaryReport,
    TPADailyReport,
    TPADailyReportList,
    GasCompositionReportList,
    ShiftReportList,
    DeliveryGasFuelGasReportList,
    AverageGasReportList,
    GasDeliveryPerformanceReportList,
    ActualSupplyDemandReportList,
    InputManageBooking,
    InputManageNomWeek,
    InputManageNomDay,
    InputManageMeterDay,
    InputManageMeterMonth,
    InputManageAllocation,
    ViewerReportBooking,
    ViewerReportNomDay,
    ViewerReportAllocation,
    ViewerReportMeterMonth,
});

export default rootReducer;